import React from "react";
import { Space } from "antd";

const TabTitle: React.SFC<{ icon: React.ReactNode }> = (props) => {
  return (
    <Space align="start" className="w-full">
      {props.icon}
      <span>{props.children}</span>
    </Space>
  );
};

export default TabTitle;
